import { apiProxyRequest } from "Api/apiProxyRequest";

import type { BillingProfileAddons } from "../types";

export const getProfileAddonsRequest = (billingProfileId: string) =>
  apiProxyRequest<BillingProfileAddons>(
    `/billing/profiles/${billingProfileId}/addons`
  );
